export default "__VITE_ASSET__Lj34Y15N__"